import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { ActivityItemByCodePayload, ActivityItemByZIdentifierPayload } from "./@types";

export const fetchActivityItemByCode = async (payload: ActivityItemByCodePayload) => {
  const { fieldglassId, activityCode } = payload;
  const { data } = await apiInputService.get(
    `/activityItem/fieldglassId/${fieldglassId}/${activityCode}`
  );

  return data;
};

export const fetchActivityItemDetails = async (payload: ActivityItemByZIdentifierPayload) => {
  const { fieldglassId, zIdentifier } = payload;
  const { data } = await apiInputService.get(
    `/frontend/activityItem/${fieldglassId}/${zIdentifier}`
  );
  return data;
};

export const useActivityItemByCode = (
  payload: ActivityItemByCodePayload,
  options?: any
) => {
  return useQuery<any>(
    ["activity-item-by-code", payload?.fieldglassId],
    () => fetchActivityItemByCode(payload),
    {
      ...options,
      cacheTime: 0
    }
  );
};
